<template>
  <div id="container"></div>
</template>

<script>
//引入缺德地图
import AMapLoader from "@amap/amap-jsapi-loader";
//引入弹出框组件
window._AMapSecurityConfig = {
  securityJsCode: "",
};
export default {
  data() {
    return {
      map: null,
      marker: null,
      mapModule: null,
    };
  },
  props: ["long", "lat"],
  mounted() {
    //DOM初始化完成进行地图初始化
    this.initMap();

    // this.changeOption();
  },
  methods: {
    initMap() {
      const _this = this;
      AMapLoader.load({
        key: "2451f1af2ac59aab13d233b3a5bb2ca6", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.PlaceSearch"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          _this.mapModule = AMap;
          _this.map = new AMap.Map("container", {
            //设置地图容器id
            viewMode: "3D", //是否为3D地图模式
            zoom: 15.8, //初始化地图级别
            center: [
              this.long === null ? 113.382675 + 0.025 : this.long + 0.0001,
              this.lat === null ? 23.038572 - 0.005 : this.lat - 0.0001,
            ], //初始化地图中心点位置
            pitch: 40, // 地图俯仰角度，有效范围 0 度- 83 度

            buildingAnimation: true, //楼块出现是否带动画
          });
          // 搜索功能
          // _this.toSearch();

          this.markPoints();
          this.latitude();

          // this.select();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //遍历显示标记点
    markPoints() {
      // 创建一个 Marker 实例：

      const marker = new AMap.Marker({
        position: new AMap.LngLat(
          this.long === null ? 113.382675 : this.long,
          this.lat === null ? 23.038572 : this.lat
        ), // 经纬度对象，也可以是经纬度构成的一维数组[lng, lat]
      });
      this.marker = marker;
      // 将创建的点标记添加到已有的地图实例：
      this.map.add(marker);

      //给标记点添加事件
      // marker.on("click", (e) => {
      //   this.setInfoWindows(e, item);
      // });
    },
    //显示的弹出框组件
    setInfoWindows(e, item) {
      let content = [
        // e.pos[0],e.pos[1],
        `<div style='\'padding:0px' 0px = '' 4px; \'=''><b>游戏地点</b>`,
        `详情 ：游戏地点`,
        `<img src=${item.img} alt="" style="width: 100px;height: 100px">`,
      ];
      // 创建 infoWindow 实例
      let infoWindow = new AMap.InfoWindow({
        content: content.join("<br>"), //传入 dom 对象，或者 html 字符串
      });
      // 打开信息窗体
      let dd = this.map.getCenter();
      // dd.pos = [e.pos[0], e.pos[1]]
      dd.lat = item.latitude;
      dd.lng = item.longitude;

      infoWindow.open(this.map, dd);
    },
    //点击获取经纬度
    latitude() {
      this.map.on("click", (ev) => {
        // console.log(ev)
        // 触发事件的对象
        let target = ev.target;
        // 触发事件的地理坐标，AMap.LngLat 类型
        let lnglat = ev.lnglat;

        this.marker.setPosition([ev.lnglat.getLng(), ev.lnglat.getLat()]); //更新点标记位置

        this.$emit("changePos", ev.lnglat.getLng(), ev.lnglat.getLat());
        // 触发事件的像素坐标，AMap.Pixel 类型
        let pixel = ev.pixel;
        // 触发事件类型
        let type = ev.type;
      });
    },
    toSearch() {
      var keywords = "北京大学";
      AMap.plugin("AMap.PlaceSearch", function () {
        var autoOptions = {
          city: "北京",
        };
        var placeSearch = new AMap.PlaceSearch(autoOptions);
        placeSearch.search(keywords, function (status, result) {
          // 搜索成功时，result即是对应的匹配数据
          console.log(result);
        });
      });
    },
    select(e) {
      const _this = this;
      var keywords = "北京";
      console.log(123);
      // 无需再手动执行search方法，autoComplete会根据传入input对应的DOM动态触发search
      // { map: _this.map } ==> 这个对象是能配置的 --> 根据官方文档配置即可，需要什么配置什么
      const placeSearch = new _this.mapModule.PlaceSearch({
        map: _this.map,
      });

      console.log(placeSearch);
      placeSearch.search(keywords, function (status, result) {
        // 搜索成功时，result即是对应的匹配数据

        console.log(status);
        console.log(result);
      });
    },
  },
};
</script>

<style lang="less" scoped>
#container {
  margin-left: 10px;
  width: 100%;
  height: 600px;
}
</style>
